<template>
  <div>
    <div style="top: 30px; left:10px !important;bottom: auto !important" class="fixed-action-btn vertical ">
      <div>
        <a class="btn blue darken-4" @click="this.$broadcast('modal::open', 'events')">
          <span style="vertical-align: top;">{{ $t("login.news") }}</span>
          <i class="material-icons">menu</i>
        </a>
      </div>
    </div>
    <div style ="top: 30px; right: 30px; bottom: auto !important" class="fixed-action-btn vertical ">
      <div>
        <a class="btn green darken-4">
          <span style="vertical-align: top;">{{ $t("login.links") }}</span>
          <i class="material-icons">menu</i>
        </a>
        
      </div>
       <ul style="bottom: auto !important">
        <li v-for="enlace in enlaces" :key="enlace.url">
          <a :href="enlace.url" target="_blank" class="btn-floating btn-large" :class="enlace.color" style="right: 20px; vertical-align: top;width: 160px; height: 25px;" @click="openVideoSave()">
            <span style="vertical-align: top;">{{ enlace.title }}</span>
          </a>
        </li>
      </ul>
      <!-- <ul style ="bottom: auto !important">
        <li><a href="https://academiadeajedrez.es" target="_blank" class="btn-floating btn-large blue darken-4" style="right: 20px; vertical-align: top;width: 160px; height: 25px;"><span style="vertical-align: top;">Academia de ajedrez</span></a></li>
        <li><a href="https://festival.mainchess.com" target="_blank" class="btn-floating btn-large purple darken-4" style="right: 20px; vertical-align: top;width: 160px; height: 25px;" @click="openVideoSave()"><span style="vertical-align: top;">Festival</span></a></li>
        <li><a href="https://salamancaajedrez.com" target="_blank" class="btn-floating btn-large green darken-4" style="right: 20px; vertical-align: top;width: 160px; height: 25px;" @click="openVideoSave()"><span style="vertical-align: top;">Salamanca ajedrez</span></a></li>
      </ul> -->
    </div>
    <div class="loguinForm center">
        <div class="col s12 m12 l12 card-panel center" >
            <p class="version">V. {{ convertirFechaAVersion(buildDate) }}</p>
            <!--<img height="40px" class="imagedropshadow" src="../../../../static/images/salamancatech-salamanca.svg" />
            <img height="40px" class="imagedropshadow" src="../../../../static/images/salamancatech-tech.svg" />-->
            <p></p>
            <div id="stripped" class="">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 971 1069">
              <polyline points="0,154 131,0 0,348 269,0 0,562 437,0 
                0,766 565,14 0,1062 719,0 289,1062 843,0 543,1062 995,0 729,1062 1161,0 947,1062 1307,0 1143,1062 1500,162 1299,1062 1500,830"/>
              </svg>
            </div>
            <!--<img width="30%" class="logo imagedropshadow" src="../../../assets/logo.svg" />-->
            <!--<canvas id="canv"></canvas>
            <div class="sky">
            </div>-->
            <form id="loginForm" v-on:submit.prevent="userloguin()" >
                <b v-if="error && error !== ''">{{ $t("login.errors." + error) }}</b>
                <div class="row">
                    <md-input  style="z-index: 9" class="input-field col s11 l12"
                            name="username"
                            :value.sync="user.username"
                    >
                        {{ $t("login.username") }}
                        <template slot="icon-name">account_circle</template>
                    </md-input>
                    <md-input style="z-index: 9" class="input-field col s11 l12"
                            type="password"
                            name="password"
                            :value.sync="user.password"
                    >
                        {{ $t("login.password") }}
                        <template slot="icon-name">lock</template>
                    </md-input>
                    <md-input style="z-index: 9" class="input-field col s9 l10 m9"
                            name="cpatchaTextBox"
                            :value.sync="cpatchaTextBox"
                    >
                        Capcha
                        <template slot="icon-name">spellcheck</template>
                    </md-input>
                    <span id="captcha" class="input-field col s2 l2 m2"></span>
                    <div class="input-field col s12 l12">
                        <md-btn id="loginbtn" class="btn waves-effect waves-light col s12 l12 purple darken-4 middle" type="submit">
                            {{ $t("login.title") }}
                        </md-btn>
                    </div>
                </div>
                
                <div class="input-field col s12" style="margin-top: auto">
            <a style="font-size: small; color: #5c005c !important;"  @click.prevent="newaccount()" v-link="{name: 'register'}">{{
                $t("login.createaccount") }}</a>
        </div>
        <div class="input-field col s12" style="margin-top: auto;padding: 10px;">
            <a style="font-size: small; color: #5c005c !important;" @click.prevent="guest()" v-link="{name: 'guest'}">{{
                $t("login.createguest") }}</a>
        </div>
            <div v-if="debug === true" >
              <md-button v-for="usertest in usertests" class="waves-effect waves-light purple darken-4" v-bind:key="usertest" style="margin-right: 10px;" @click="userloguinTest({username: usertest, password: 'password', club:'General'})">
                {{ usertest }}
              </md-button>
          </div>
            </form>
          <blockquote class="chip">
            <a class="" href="mailto:info@mainchess.com">
                info@mainchess.com
            </a>
          </blockquote>
          <hr style="height:2px;border-width:0;color:gray;background-color:#5c005c;margin:0;">
          <div style="height: auto">
            <span style="font-size: small;"><b>{{  countUsers }}</b> {{ $t("login.users") }} | </span>
            <span style="font-size: small;"><b>{{  countBoards }}</b> {{ $t("login.games") }} | </span>
            <span style="font-size: small;"><b>{{  countPuzles }}</b> {{ $t("login.lessons") }} | </span>
            <span style="font-size: small;"><b>{{  countClubs }}</b> 
            <a href="#" style="color:#5c005c; text-decoration: underline;margin-right: 10px;" @click="this.$broadcast('modal::open', 'clubsInformation')">
              {{ $t("login.platformclubs") }}
            </a>
            </span>

          </div>
        </div>
            
        
        <!-- <legend class="festival">III Festival de Ajedrez "Salamanca Cuna del Ajedrez Moderno"</legend>
        <fieldset class="col s12">
                      <p></p>
                      !--<a href = "https://www.salamancachessfestival.com"><img class="festivalimg" src="../../../../static/images/festival2021/IIIFestival_Ajedrez-1024x576.jpg"/></a>--
                      <div class="input-field col s12" style="margin-top: auto">
                          <a style="font-size: small; color: #5c005c !important;" v-link="{name: 'register'}">{{
                              $t("login.createaccount") }}</a>
                      </div>
                      <div class="input-field col s12" style="margin-top: auto;padding: 10px;">
                          <a class="btn waves-effect waves-light col s12 purple darken-4"  v-link="{name: 'guest'}">{{
                              $t("login.createguest") }}</a>
                      </div>
        </fieldset>-->
    </div>
  
    <md-modal id="clubsInformation" class="">
      <h3 class="header">Estadísticas de uso</h3>
      <p style="font-size: small;">
        <b>{{ usersByClub.length }}</b> clubs con datos<br>
        <b>{{ formatTime(totalClubTime.toFixed(2)) }}</b> tiempo total acumulado
      </p>

      <div style="overflow-x: auto;">
        <table class="highlight responsive-table">
          <thead>
            <tr>
              <th>Club</th>
              <th>Usuarios</th>
              <th>Tiempo Total</th>
              <th>Media</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="club in usersByClub" :key="club._id">
              <td>{{ club._id || 'Sin asignar' }}</td>
              <td>{{ club.count }}</td>
              <td>{{ formatTime(club.totalTime) ? formatTime(club.totalTime.toFixed(2)) : '0.00' }}</td>
              <td>{{ formatTime((club.totalTime / club.count).toFixed(2)) }}</td> <!-- Cálculo directo -->
            </tr>
          </tbody>
        </table>
      </div>
    </md-modal>
    <md-modal id="events" bottom class="">
      <h3 class="header">{{ $t("login.news") }}</h3>
      <ul class="collection">
        <li v-for="noticia in noticias" :key="noticia.title" class="center-align hoverable collection-item avatar">
          <img v-if="noticia.image" :src="noticia.image" alt="img-responsive" class="responsive-img" style="max-width: 600px;">
          <i v-else class="material-icons">info</i>
          <p></p>
          <span class="title">{{ noticia.title }}</span>
          <p>
            {{ noticia.description }}
            <br>
            <a v-if="noticia.link" :href="noticia.link" target="_blank" class="btn waves-effect waves-light btn-small">ENLACE</a>
          </p>
          <a href="#!" class="secondary-content">
            <i class="material-icons">grade</i>
          </a>
        </li>
      </ul>
    </md-modal>
    <md-modal id="loadClub" class="modal-fixed-footer">
      <blockquote><h4>Seleccione la sala en la que quiere participar:</h4></blockquote>
      
      <md-radio-group group="rolegroup">
        
            <md-radio v-for="club in tournamentClubsAll"
      :key="club._id"
      :value.sync="newClub"
      :class="'row s12 m12 l12 loguin with-gap col'"
      v-model="newClub"
      :radio-value="club.name || club._id"
      style="padding:20px">
      <div :class="club.isTournament ? 'col s12 m12 l12 tournament' : 'col s12 m12 l12'" :style="{'padding': club.isTournament ? '10px' : '0px'}">
          <div >
                <div>
                  <img class="top left img-responsive" style="height:60px;" v-bind:src="getImageClub(club)" alt="" @error="imageUrlAlt"/>
                  <span class="left" style="padding: 18px;"><b>{{ club.name }}</b> <span v-if="club.description.length > 0"> / </span>{{ club.description }}</span>
                  <a v-show="club.link" class="btn-floating red right" :href= club.link target="_blank" style="margin-top:18px;"><i class="material-icons">link</i></a>
                </div>
                </div>
        </div>
            </md-radio>
          
        
       <!--
        <div class="col s12 m12 l12">
          <div class="row">
            <md-radio :value.sync="newClub" :class="'loguin with-gap col'"  v-model="newClub" :radio-value="campeonato1" style="padding:20px">
                <div>
                  <img class="top left img-responsive" style="height:60px;" v-bind:src="campeonato1image" alt="" @error="imageUrlAlt"/>
                  <span class="left" style="padding: 18px;"><b>{{ campeonato1 }}</b> / {{ campeonato1descr }}</span>
                  <a v-show="true" class="btn-floating red right" :href=campeonato1link target="_blank" style="margin-top:18px;"><i class="material-icons">link</i></a>
                </div>
            </md-radio>
          </div>
        </div>
      -->
      </md-radio-group>
      <span slot="footer" style="height: 20%;">
        <md-button v-if="newClub.length > 0" class="waves-effect waves-light purple darken-4" style="margin-right: 10px;" @click="acceptClub()">
          {{ $t("game.accept") }}
        </md-button>
        <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'loadClub')">
          {{ $t("home.createPart.cancel") }}
          <md-icon right>cancel</md-icon>
        </md-button>
      </span>
    </md-modal>
    <md-modal id="termsModal" class="modal-fixed-footer">
      <blockquote><h5>Términos, condiciones y políticas de privacidad</h5></blockquote>
  <p>Fecha de última actualización: 26 de julio de 2023</p>
  
  <h6 style="color:#5c005c">1. Uso del sitio web</h6>
  <ul>
    <li>Mainchess.com es una plataforma de ajedrez en línea y está destinada únicamente para fines recreativos y de entretenimiento.</li>
    <li>Al utilizar el sitio web, garantizas que tienes la edad legal para participar en juegos en línea en tu país de residencia.</li>
  </ul>

  <h6  style="color:#5c005c">2. Responsabilidad del usuario</h6>
  <ul>
    <li>Eres responsable de mantener la confidencialidad de tu cuenta y contraseña en Mainchess.com.</li>
    <li>Te comprometes a no utilizar Mainchess.com para actividades ilegales o que violen los derechos de terceros.</li>
    <li>No puedes utilizar ningún tipo de software o herramientas que otorguen una ventaja injusta durante las partidas.</li>
  </ul>

  <h6  style="color:#5c005c">3. Propiedad intelectual</h6>
  <p>Todo el contenido presente en Mainchess.com, incluyendo pero no limitado a logotipos, imágenes, texto y software, está protegido por leyes de propiedad intelectual y derechos de autor.</p>

  <h6  style="color:#5c005c">4. Limitación de responsabilidad</h6>
  <p>Mainchess.com no se hace responsable de los daños directos, indirectos, incidentales o consecuenciales que puedan surgir del uso o la imposibilidad de uso del sitio web.</p>

  <h6  style="color:#5c005c">5. Política de privacidad</h6>
  <p>Mainchess.com recopilará y almacenará cierta información personal con el fin de mejorar tu experiencia en el sitio web. Esta información será tratada de acuerdo con nuestra Política de Privacidad.</p>

  <h6   style="color:#5c005c">6. Suspensión o terminación de la cuenta</h6>
  <p>Mainchess.com se reserva el derecho de suspender o terminar tu cuenta en caso de violación de nuestros Términos y Condiciones, o si se sospecha de un uso indebido del sitio web.</p>

  <h6  style="color:#5c005c">7. Modificaciones en los términos y condiciones</h6>
  <p>Mainchess.com se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento y sin previo aviso. Las modificaciones serán efectivas a partir de su publicación en el sitio web.</p>

  <h6  style="color:#5c005c">8. Ley aplicable y jurisdicción</h6>
  <p>Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de España, y cualquier disputa que surja en relación con Mainchess.com estará sujeta a la jurisdicción exclusiva de los tribunales de Salamanca.</p>
  
  <p>Gracias por leer nuestros términos, condiciones y políticas de privacidad. Esperamos que disfrutes tu experiencia en Mainchess.com y te diviertas jugando al ajedrez en línea. ¡Buena suerte!</p>
      
      <span slot="footer" style="height: 20%;">
        <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'termsModal')">
          {{ $t("about.close") }}
          <md-icon right>close</md-icon>
        </md-button>
      </span>
    </md-modal>
        <!-- BEGIN COOKIE INFO BAR -->
<div class="cookies-infobar">
  {{ $t("login.terms_text") }}<br/>
  <a href="#" style="color:#5c005c; text-decoration: underline;margin-right: 10px;" @click="this.$broadcast('modal::open', 'termsModal')">
         {{ $t("login.terms") }}
   </a>
  <div class="cookies-infobar_wrapper">
    <a href="#" id="cookies-infobar-close" class="waves-effect waves-light purple darken-4 cookies-infobar_btn">{{ $t("game.accept") }}</a>
    <a href="about:blank" class="waves-effect waves-light purple darken-4 cookies-infobar_btn">{{ $t("register.cancel") }}</a>
  </div>
</div>
<!-- CLOSE COOKIE INFO BAR -->
</div>
</template>
<script>
import UserService from '../../../services/user'
import Storage from '../../../services/lstorage'
import toast from 'vue-material-components'
import config from '../../../../server/config.js'
import ClubService from '../../../services/club'
// import Jquery from 'jquery'
import moment from 'moment'
export default {
  route: {
    canActivate: function (transition) {
      if (UserService.user_acces('authenticate')) {
        // this.toast('<span>Bienvenido a Mainchess</span>', 10000, 'rounded')
        return transition.redirect('/home')
      } else {
        return true
      }
    }
  },
  data () {
    return {
      countUsers: 0,
      countBoards: 0,
      countPuzles: 0,
      countClubs: 0,
      usersByClub: '',
      totalClubTime: '',
      totalClubCount: '',
      usertests: ['admin', 'user1', 'user2', 'user3', 'user4', 'user5', 'user6', 'user7', 'user8', 'user9', 'teacher',
        'user10', 'user11', 'user12', 'user13', 'user14', 'user15', 'user16', 'user17', 'user18', 'user19'],
      user: {
        username: '',
        password: '',
        club: '',
        club1: '',
        club2: '',
        club3: '',
        club4: '',
        imagesclub: [],
        passwordclub: [],
        descripcionclub: [],
        linkclub: []
      },
      campeonato1: 'Campeonato1',
      campeonato1link: 'https://academiadeajedrez.es',
      campeonato1image: '../../../static/images/50x50defaultClub.png',
      campeonato1descr: 'descipción',
      noticias: {},
      enlaces: {},
      buildDate: process.env.VUE_APP_BUILD_DATE,
      debug: config.debug,
      data: {},
      error: '',
      fechaActual: new Date().toLocaleDateString(),
      newClub: '',
      code: '',
      captaText: '',
      allClubs: []
    }
  },
  mixins: [
    toast
  ],
  computed: {
    tournamentClubsAll () {
      // window.alert(JSON.stringify(this.user))
      if (!Array.isArray(this.allClubs)) return []
      return this.allClubs.filter(club => club.isTournament ||
        (club.name === this.user.club || club.name === this.user.club1 || club.name === this.user.club2 || club.name === this.user.club3 || club.name === this.user.club4))
    }
  },
  methods: {
    getImageClub (club) {
      if (club && club.image) {
        return Storage.get('serverDir') + '/uploads/' + club.image
      } else {
        return '../../../static/images/50x50defaultClub.png'
      }
    },
    fetchAllClubs () {
      ClubService.get(this, {}).then(response => {
        try {
          const clubs = JSON.parse(response)
          this.allClubs = clubs
        } catch (e) {
          this.allClubs = []
        }
      })
    },
    fetchNoticias () {
      fetch('../../../static/data/noticias.json')
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al cargar las noticias')
          }
          return response.json()
        })
        .then(data => {
          this.noticias = data
          // window.alert(JSON.stringify(this.noticias[0].title))
        })
        .catch(error => {
          console.error('Hubo un error al cargar las noticias: ', error)
        })
    },
    fetchLinks () {
      fetch('../../../static/data/enlaces.json')
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al cargar los enlaces')
          }
          return response.json()
        })
        .then(data => {
          this.enlaces = data
        })
        .catch(error => {
          console.error('Hubo un error al cargar los enlaces: ', error)
        })
    },
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2')
      }
      return x1 + x2
    },
    getNum () {
      var data = {
        _id: this.user._id
      }
      var _self = this
      UserService.getNum(this, data).then(function (response) {
        const dd = JSON.parse(response)
        _self.countUsers = this.addCommas(dd.counts.countUser)
        _self.countBoards = this.addCommas(dd.counts.countBoard)
        _self.countPuzles = this.addCommas(dd.counts.countPuzle)
        _self.countClubs = this.addCommas(dd.counts.countClub)
        _self.usersByClub = dd.counts.usersByClub
        _self.totalClubTime = dd.counts.totalClubTime
        _self.totalClubCount = dd.counts.totalClubCount
        // window.alert(JSON.stringify(dd.counts.usersByClub))
      }, function (response) {
        _self.countUsers = 2000
      })
      var counts = {
        countUsers: this.countUsers,
        countBoards: this.countBoards,
        countPuzles: this.countPuzles,
        countClubs: this.countClubs,
        usersByClub: this.usersByClub
      }
      return counts
    },
    wellcome (data) {
      // this.toast('<span><h4>Bienvenido ' + data.name + ' (' + data.club + ') </h4>', 2000, 'rounded')
      // window.alert('Hola ' + data.name + ' (' + data.club + ') ' + '\n\nBienvenido a Mainchess')
      // this.$broadcast('modal::close', 'some', 'usersConnect')
      // window.alert('login' + JSON.stringify(this.user))
      this.user.club2 = data.club2
      this.user.club1 = data.club1
      this.user.club3 = data.club3
      this.user.club4 = data.club4
      this.user.club = data.club
      // window.alert('login' + JSON.stringify(this.user))
      this.getDataClub(data.club, 0)
      this.getDataClub(data.club1, 1)
      this.getDataClub(data.club2, 2)
      this.getDataClub(data.club3, 3)
      this.getDataClub(data.club4, 4)
      const eventoLanzadoKey = 'retoLanzado'
      localStorage.setItem(eventoLanzadoKey, 'false')
      setTimeout(function () {
        this.$broadcast('modal::open', 'loadClub')
      }.bind(this), 500)
    },
    convertirFechaAVersion (fecha) {
      const fechaObj = new Date(fecha)
      const anio = fechaObj.getFullYear().toString().slice(-2)
      const mes = fechaObj.getMonth() + 1 // Los meses en JavaScript van de 0 a 11
      const dia = fechaObj.getDate()
      // Asegurarse de que el mes y el día tengan siempre dos dígitos
      const mesConCeros = mes.toString().padStart(2, '0')
      const diaConCeros = dia.toString().padStart(2, '0')
      // Concatenar el año, mes y día como un número de versión
      // const version = parseInt(`${anio}${mesConCeros}${diaConCeros}`)
      const version = `${anio}.${mesConCeros}.${diaConCeros}`
      return version
    },
    acceptClub () {
      this.$broadcast('modal::close', 'some', 'loadClub')

      /* var club1 = this.data.data.club1
      var club2 = this.data.data.club2
      var club = this.data.data.club
      // Actualizar los valores de los clubes
      if (this.newClub === club1) {
        this.data.data.club = club1 // El nuevo club pasa a ser el principal
        this.data.data.club1 = club // El antiguo club principal pasa a club1
      } else if (this.newClub === club2) {
        this.data.data.club = club2 // El nuevo club pasa a ser el principal
        this.data.data.club2 = club // El antiguo club principal pasa a club2
      } else {
      } */
      this.data.data.club = this.newClub // Asignar el nuevo club como el principal
      // Asignar el nuevo club como el principa l
      // window.alert(this.data.data.club + ' ' + this.data.data.club1 + ' ' + this.data.data.club2)
      // window.alert(JSON.stringify(this.data.data))
      /* var dataClub = {
        _id: this.user._id,
        club: this.newClub
      }*/
      // window.alert('color ' + mycolor + 'ELO: ' + this.user.elo + ' -> ' + xnuevoElo + 'color: ' + result.result.color + 'motiv: ' + result.result.motiv)
      // UserService.updateClub(this, dataClub)
      Storage.set('token', this.data.token)
      // window.alert(JSON.stringify(this.data.data.firstName))
      UserService.setUser(this.data.data)
      /* UserService.signin(this, {_id: this.user._id, club: this.newClub, password: ''}).then(function (response) {
      })*/
      this.$dispatch('userLoguin', 'user loguin')
      // this.toast('<span>Bienvenido a Mainchess</span>', 10000, 'rounded')
      window.location.reload()
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultClub.png'
    },
    getDataClub (clubName, number) {
      var parms = {
        name: clubName
      }
      var _self = this
      ClubService.get(_self, parms).then(function (response) {
        const theD = JSON.parse(response)
        _self.clubs = theD
        if (_self.clubs.length > 0 && _self.clubs[0]) {
          _self.user.imagesclub[number] = Storage.get('serverDir') + '/uploads/' + _self.clubs[0].image
          _self.user.passwordclub[number] = _self.clubs[0].password
          _self.user.descripcionclub[number] = _self.clubs[0].description
          _self.user.linkclub[number] = _self.clubs[0].link
        } else {
          _self.user.imagesclub[number] = ''
          _self.user.passwordclub[number] = ''
          _self.user.descripcionclub[number] = ''
          _self.user.linkclub[number] = ''
        }
      })
    },
    formatTime (seconds) {
      const duration = moment.duration(seconds, 'seconds')
      const months = Math.floor(duration.asMonths())
      const days = duration.days()
      // const hours = duration.hours()
      // const minutes = duration.minutes()
      // const secs = duration.seconds()
      let formattedTime = ''
      if (months > 0) {
        formattedTime += `${months} meses `
      }
      if (days > 0) {
        formattedTime += `${days} días `
      }
      formattedTime += moment.utc(duration.asMilliseconds()).format('HH:mm:ss')
      return formattedTime.trim()
    },
    createCaptcha () {
      // clear the contents of captcha div first
      document.getElementById('captcha').innerHTML = ''
      // var charsArray = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*'
      var charsArray = '0123456789abcdefghijklmnopqrstuvwxyz'
      var lengthOtp = 3
      var captcha = []
      for (var i = 0; i < lengthOtp; i++) {
        // below code will not allow Repetition of Characters
        var index = Math.floor(Math.random() * charsArray.length + 1) // get the next character from the array
        if (captcha.indexOf(charsArray[index]) === -1) {
          captcha.push(charsArray[index])
        } else {
          i--
        }
      }
      var canv = document.createElement('canvas')
      canv.id = 'captcha'
      canv.width = 100
      canv.height = 30
      var ctx = canv.getContext('2d')
      ctx.font = '25px Georgia'
      ctx.textAlign = 'start'
      ctx.textBaseline = 'bottom'
      ctx.fillStyle = '#5c005c'
      ctx.fillText(captcha.join(''), 0, 30)
      // storing captcha so that can validate you can save it somewhere else according to your specific requirements
      this.code = captcha.join('')
      document.getElementById('captcha').appendChild(canv) // adds the canvas to the body element
    },
    validateCaptcha () {
      var ret = false
      window.event.preventDefault()
      // debugger
      if (this.cpatchaTextBox === this.code) {
        // window.alert('Valid Captcha')
        ret = true
      } else {
        this.toast('<span><h4>Capcha inválido, inténtelo de nuevo</h4>', 3000, 'rounded')
        // window.alert('Capcha inválido, inténtelo de nuevo')
        this.createCaptcha()
        ret = false
      }
      return ret
    },
    newaccount () {
      if (this.validateCaptcha()) {
        this.$route.router.go('/user/register')
      }
    },
    guest () {
      if (this.validateCaptcha()) {
        this.$route.router.go('/user/guest')
      }
    },
    friendlyError (error) {
      switch (error) {
        case 'user_not_found': return 'Usuario no encontrado'
        case 'passw_incorrect': return 'Contraseña incorrecta'
        case 'internal_server_error': return 'Error interno del servidor'
        case 'consultando': return 'Consultando...'
        default: return 'Error desconocido'
      }
    },
    userloguin () {
      if (this.validateCaptcha() === true) {
        this.error = 'consultando'
        this.user.login = new Date().getTime()

        UserService.authenticate(this, this.user)
          .then(r => {
            if (r.status === 200) {
              return r.text()
            } else {
              return r.text().then(d => {
                throw d
              })
            }
          })
          .then(json => {
            const data = JSON.parse(json)
            this.data = data
            this.wellcome(data.data)
          })
          .catch(err => {
            // err será un string como 'user_not_found'
            this.error = err.text() // this.friendlyError(err)
            window.swal(this.error)
          })
      }
    },
    userloguinTest (user) {
      this.error = 'consultando'
      if (user.username === 'admin') {
        user.password = 'ChessPlaza2020'
      }
      UserService.authenticate(this, user).then(r => {
        if (r.status === 200) {
          return r.text()
        } else {
          return r.text().then(d => {
            throw d
          })
        }
      })
			.then(json => {
  const eventoLanzadoKey = 'retoLanzado'
  localStorage.setItem(eventoLanzadoKey, 'false')
  const data = JSON.parse(json)
  this.data = data
  /* var dataClub = {
    _id: this.user._id,
    club: this.newClub
  }*/
  // UserService.updateClub(this, dataClub)
  Storage.set('token', this.data.token)
  UserService.setUser(this.data.data)
  /* UserService.signin(this, {_id: this.user._id, club: this.newClub, password: ''}).then(function (response) {
  })*/
  this.$dispatch('userLoguin', 'user loguin')
  window.location.reload()
      // this.toast('<span>Bienv
}).catch(err => {
  if (err.text) {
    err.text().then(texto => {
      this.error = texto
    })
  } else {
    this.error = err.message || 'Error desconocido'
  }
})
    }
  },
  ready () {
    this.createCaptcha()
    this.fetchNoticias()
    this.fetchLinks()
    let bannerScript = document.createElement('script')
    bannerScript.setAttribute('src', '../../../static/js/cookiebanner.min.js')
    document.head.appendChild(bannerScript)
    this.getNum()
    this.fetchAllClubs()
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    document.title = 'Mainchess - ' + this.$t('login.title')
    let logo1 = document.getElementById('logo')
    if (logo1) {
      logo1.style += 'animation-play-state: running;'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@-ms-viewport {
  width: device-width;
}

 .loguinForm{
  margin: auto;
  width: 40%;
  padding: 10px;
} 
@media screen and ( max-width: 782px ) {
 .loguinForm{
  width: 90%;
 }
}

.imagedropshadow {
    padding: 5px;
}
fieldset
{
  border:2px solid #5c005c !important;
}
.festival {
  margin-top: 10px;
  font-size: medium;
  color: green !important;
  
}
.festivalimg {
  width: 50%;
  padding: 10px;
  text-decoration: none;
  transition: transform .3s; /* Animation */
  margin: 0 auto;
}
.festivalimg:hover{
  transform: scale(1.2);
}
.version {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 10px;
    color: white;
    background-color: transparent;
    font-size: smaller;
}

.fixed-action-btn ul 
{
  top: 80px !important;
}


 .cookies-infobar {
  background: #C2B0DA;
  color: #000;
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  text-align: center;
}

.cookies-infobar.cookies-infobar_accepted {
  display: none;
}

.cookies-infobar_wrapper {
  margin: 10px;
}

.cookies-infobar a {
  color: white;
}

.cookies-infobar_btn {
  display: inline-block;
  padding: 5px 10px;
  background: #5c005c;
  text-decoration: none;
  border-radius: 3px;
  text-transform: uppercase;
  font-size: 1.2em;
  color: white;
}

.logo {
  animation-name: logoAnimation;
  animation-duration: 6s;
  animation-timing-function: ease-in-out;
  animation-delay: 1;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
  width: 200px;
}

@keyframes logoAnimation {
  from {
    opacity: 0;
    transform: translateX(-200px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes scribble {
  to {
    stroke-dashoffset: 0;
  }
}
body { background: white; }

div#stripped {
  animation-duration: 16s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
  max-width: 220px;
  margin: 0 auto;
  background: white;
  background-size: cover;
  font-size: 0;
  background-image: url(../../../../static/images/logo.svg);
}
div#stripped svg {
  background: #fff;
  mix-blend-mode: lighten;
  
}


div#stripped svg polyline {
  fill: none;
  stroke: black;
  stroke-width: 200;
  stroke-dasharray: 20000;
  stroke-dashoffset: 20000;
  animation: scribble 7s linear forwards;
}
@media 
(-webkit-min-device-pixel-ratio: 2), 
(min-resolution: 192dpi) { 
}

div#events {
    min-height: auto !important;
}

.tournament {
    background-color: #f3e5f5 !important;
    border: 1px solid #5c005c !important;
    border-radius: 10px;
  }

</style>



// WEBPACK FOOTER //
// index.vue?4df9d2d2